import { render, staticRenderFns } from "./SoundResourceContentEditor.vue?vue&type=template&id=7efd730f&scoped=true"
import script from "./SoundResourceContentEditor.vue?vue&type=script&lang=js"
export * from "./SoundResourceContentEditor.vue?vue&type=script&lang=js"
import style0 from "./SoundResourceContentEditor.vue?vue&type=style&index=0&id=7efd730f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd730f",
  null
  
)

export default component.exports